import { TFacilityStatusInput } from "redux/reducers/models/facility";
import { useDropEditInputRow } from "hooks/editInputDragAndDrop/useDropEditInputRow/useDropEditInputRow";
import React, { useEffect, useRef } from "react";
import { useStatusInputContext } from "../StatusInputContextProvider";
import "./editStatusInputRow.scss";
import EditStatusInput from "./EditStatusInput";

interface IProps {
  inputRow: string;
  inputs: TFacilityStatusInput[];
}

export default function EditStatusInputRow(props: IProps) {
  const { inputRow, inputs } = props;

  const statusInputContext = useStatusInputContext();

  const rowRef = useRef<HTMLDivElement>(null);

  const inputContainerRefs = useRef<HTMLDivElement[]>([]);

  const { drop, canDrop, isOver, customDragLayer } = useDropEditInputRow(
    inputs,
    rowRef,
    statusInputContext.inputRowsContainer.updatedState,
    inputRow,
    inputContainerRefs,
    statusInputContext.inputRowsContainerActions.update,
    [
      { types: ["input", "select"], maxSize: 3 },
      { types: ["checkbox"], maxSize: 3 },
      { types: ["text"], maxSize: 1 },
    ],
  );

  useEffect(() => {
    if (inputs) {
      const numInputs = inputs.length;

      inputContainerRefs.current = inputContainerRefs.current.slice(0, numInputs);
    }
  }, [inputs]);

  return (
    <div
      ref={el => {
        drop(el);
        rowRef.current = el;
      }}
      className="status-edit-input-row"
      style={{
        outline: isOver && !canDrop ? "1px solid red" : "none",
      }}
    >
      {inputs.map((input, index) => {
        return (
          <div
            ref={el => (inputContainerRefs.current[index] = el)}
            key={String(input.id)}
            className="status-edit-input-container"
          >
            <EditStatusInput input={input} />
          </div>
        );
      })}

      {customDragLayer}
    </div>
  );
}
